export default "__VITE_ASSET__BCz3XwzV__"